import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-mt-3" }
const _hoisted_3 = { class: "p-grid" }
const _hoisted_4 = { class: "p-col-5" }
const _hoisted_5 = { class: "p-mb-0" }
const _hoisted_6 = {
  key: 0,
  class: "p-mt-2 p-ml-5"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ~ ")
const _hoisted_8 = { class: "p-col" }
const _hoisted_9 = { class: "p-mb-0" }
const _hoisted_10 = { class: "p-mt-3" }
const _hoisted_11 = { class: "p-d-flex p-ai-center" }
const _hoisted_12 = { class: "p-d-flex p-ai-center" }
const _hoisted_13 = {
  key: 0,
  class: "p-mt-3"
}
const _hoisted_14 = { class: "p-d-flex p-jc-between" }
const _hoisted_15 = { class: "p-input-icon-left" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "p-d-flex p-ai-center"
}
const _hoisted_18 = { class: "p-d-flex p-ai-center" }
const _hoisted_19 = { class: "p-pl-2" }
const _hoisted_20 = { class: "p-d-flex p-jc-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataRole = _resolveComponent("DataRole")!
  const _component_DataType = _resolveComponent("DataType")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modal: true,
    header: _ctx.$t('automl.create.advanced.setting'),
    class: "autots-advanced-setting-dialog"
  }, {
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_20, [
        _createVNode(_component_Button, {
          label: _ctx.$t('automl.create.setting'),
          disabled: _ctx.isDisableSettingButton,
          onClick: _ctx.onClickSetting,
          autofocus: ""
        }, null, 8, ["label", "disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", null, [
        _createVNode("h5", null, _toDisplayString(_ctx.$t("autots.create.advance.title.model.list")), 1),
        _createVNode("div", _hoisted_1, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.algorithms, (model, index) => {
            return (_openBlock(), _createBlock("div", {
              key: model,
              class: "p-col-2 p-pb-0 autots-model-list"
            }, [
              _createVNode(_component_Checkbox, {
                id: `model-${index}`,
                value: model,
                modelValue: _ctx.selectedModel,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedModel = $event))
              }, null, 8, ["id", "value", "modelValue"]),
              _createVNode("label", {
                for: `model-${index}`
              }, _toDisplayString(_ctx.$t(model)), 9, ["for"])
            ]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode("h5", null, _toDisplayString(_ctx.$t("autots.create.advance.title.post.processing")), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", null, [
              _createVNode("h6", _hoisted_5, _toDisplayString(_ctx.$t("autots.create.advance.post.processing.range")), 1)
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.forecastRangeOptions, (option) => {
              return (_openBlock(), _createBlock("div", {
                key: option.key
              }, [
                _createVNode(_component_RadioButton, {
                  id: `forecastRange-${option.key}`,
                  value: option,
                  modelValue: _ctx.selectedPostProcessingTrim,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedPostProcessingTrim = $event)),
                  class: "p-mt-2"
                }, null, 8, ["id", "value", "modelValue"]),
                _createVNode("label", {
                  for: `forecastRange-${option.key}`,
                  class: "p-ml-2"
                }, _toDisplayString(_ctx.$t(option.label)), 9, ["for"])
              ]))
            }), 128)),
            (_ctx.selectedPostProcessingTrim.key === 'manual')
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode(_component_InputNumber, {
                    id: "input-forecast-range-min",
                    modelValue: _ctx.selectedPostProcessingTrimMin,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedPostProcessingTrimMin = $event)),
                    mode: "decimal",
                    class: ["forecast-range-manual p-mr-2", {
                'p-invalid':
                  _ctx.selectedPostProcessingTrim?.key === 'manual' &&
                  _ctx.selectedPostProcessingTrimMin !== undefined &&
                  _ctx.selectedPostProcessingTrimMin !== null &&
                  _ctx.selectedPostProcessingTrimMax !== undefined &&
                  _ctx.selectedPostProcessingTrimMax !== null &&
                  _ctx.selectedPostProcessingTrimMin >=
                    _ctx.selectedPostProcessingTrimMax,
              }],
                    inputStyle: "width: 7vw;"
                  }, null, 8, ["modelValue", "class"]),
                  _hoisted_7,
                  _createVNode(_component_InputNumber, {
                    id: "input-forecast-range-max",
                    modelValue: _ctx.selectedPostProcessingTrimMax,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedPostProcessingTrimMax = $event)),
                    mode: "decimal",
                    class: ["forecast-range-manual p-ml-2", {
                'p-invalid':
                  _ctx.selectedPostProcessingTrim?.key === 'manual' &&
                  _ctx.selectedPostProcessingTrimMin !== undefined &&
                  _ctx.selectedPostProcessingTrimMin !== null &&
                  _ctx.selectedPostProcessingTrimMax !== undefined &&
                  _ctx.selectedPostProcessingTrimMax !== null &&
                  _ctx.selectedPostProcessingTrimMin >=
                    _ctx.selectedPostProcessingTrimMax,
              }],
                    inputStyle: "width: 7vw;"
                  }, null, 8, ["modelValue", "class"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", null, [
              _createVNode("h6", _hoisted_9, _toDisplayString(_ctx.$t("autots.create.advance.round")), 1)
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.yesNoOptions, (option) => {
              return (_openBlock(), _createBlock("div", {
                key: option.key
              }, [
                _createVNode(_component_RadioButton, {
                  id: `forecastRound-${option.key}`,
                  value: option,
                  modelValue: _ctx.selectedPostProcessingRound,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedPostProcessingRound = $event)),
                  class: "p-mt-2"
                }, null, 8, ["id", "value", "modelValue"]),
                _createVNode("label", {
                  for: `forecastRound-${option.key}`,
                  class: "p-ml-2"
                }, _toDisplayString(_ctx.$t(option.label)), 9, ["for"])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("h5", null, _toDisplayString(_ctx.$t("autots.create.advance.title.limit.time")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.selectedLimitTime,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedLimitTime = $event)),
          options: _ctx.limitTimeList,
          optionLabel: "label",
          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeLimitTime($event)))
        }, {
          value: _withCtx((slotProps) => [
            _createVNode("div", _hoisted_11, [
              _createVNode("div", null, _toDisplayString(_ctx.$t(slotProps.value.label)), 1)
            ])
          ]),
          option: _withCtx((slotProps) => [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ]),
      (_ctx.showFeatureSelection)
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            _createVNode("h5", null, _toDisplayString(_ctx.$t("autots.create.advance.title.feature")), 1),
            _createVNode(_component_DataTable, {
              value: _ctx.autoTsSchemas,
              responsiveLayout: "scroll",
              selectionMode: "multiple",
              metaKeySelection: false,
              selection: _ctx.selectedColumn,
              "onUpdate:selection": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedColumn = $event)),
              filters: _ctx.filters,
              "onUpdate:filters": _cache[10] || (_cache[10] = ($event: any) => (_ctx.filters = $event))
            }, {
              header: _withCtx(() => [
                _createVNode("div", _hoisted_14, [
                  _createVNode("span", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.filters['global'].value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filters['global'].value = $event)),
                      placeholder: _ctx.$t('automl.create.search')
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ])
              ]),
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("automl.create.not.found")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  selectionMode: "multiple",
                  style: {"width":"3rem"}
                }),
                _createVNode(_component_Column, {
                  field: "name",
                  header: _ctx.$t('automl.create.column.name')
                }, null, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "role",
                  header: _ctx.$t('automl.create.column.role')
                }, {
                  body: _withCtx((slotProps) => [
                    (slotProps.data.role)
                      ? (_openBlock(), _createBlock("div", _hoisted_17, [
                          _createVNode(_component_DataRole, {
                            role: slotProps.data.role
                          }, null, 8, ["role"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "type",
                  header: _ctx.$t('automl.create.column.type')
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("div", _hoisted_18, [
                      _createVNode(_component_DataType, {
                        dataType: slotProps.data.type
                      }, null, 8, ["dataType"]),
                      _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t(`datasource.datatype.${slotProps.data.type}`)), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value", "selection", "filters"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["header"]))
}